import "./App.css";
import React from "react";
import { BrowserRouter as Router, Routes, Route} from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Fotos from "./pages/Fotos";
import Contact from "./pages/Contact";
import UploadImg from "./pages/uploadImg";
import FotoDetail from "./pages/FotoDetail";
import ErrorBoundary from "./pages/ErrorBoundary"; 

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="/upload/:id" element={<UploadImg />} />
          <Route path="upload" element={
            <ErrorBoundary>
              <UploadImg />
            </ErrorBoundary>
          } />
          <Route path="fotos" element={<Fotos />} />
          <Route path="/fotos/:id" element={<FotoDetail />} />
          <Route path="contact" element={<Contact />} />
          <Route path="login" element={<Login />} />
        </Route>
      </Routes>
    </Router>
  );
};

export default App;
